module.exports = __webpack_public_path__ + "assets/img/account.decaea49.svg";